import { render, staticRenderFns } from "./picView.vue?vue&type=template&id=488718a9&scoped=true&"
import script from "./picView.vue?vue&type=script&lang=js&"
export * from "./picView.vue?vue&type=script&lang=js&"
import style0 from "./picView.vue?vue&type=style&index=0&id=488718a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488718a9",
  null
  
)

export default component.exports